export function slideshow() {
  const slideshows = document.querySelectorAll('.images-slideshow');
  slideshows.forEach(slideshow => {
    // — data属性から設定を取得 —
    let images;
    try {
      images = JSON.parse(slideshow.dataset.images);
      if (!Array.isArray(images) || images.length === 0) {
        console.error('data-images must be a non-empty JSON array');
        return;
      }
    } catch (e) {
      console.error('Failed to parse data-images:', e);
      return;
    }
    const interval = parseInt(slideshow.dataset.interval, 10) || 5000;
    const randomize = slideshow.dataset.random === 'true';

    // — ランダム化（Fisher–Yates shuffle） —
    const imgList = images.slice();
    if (randomize) {
      for (let i = imgList.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [imgList[i], imgList[j]] = [imgList[j], imgList[i]];
      }
    }

    // — 先読み —
    const preloaded = imgList.map(src => {
      const img = new Image();
      img.src = src;
      return img;
    });

    // — img 要素を動的に作成して append —
    const imgEl = document.createElement('img');
    imgEl.className = 'h-100 object-fit-cover';
    imgEl.src = preloaded[0].src;
    slideshow.appendChild(imgEl);

    // — スライドショー本体 —
    let currentIndex = 0;
    setInterval(() => {
      currentIndex = (currentIndex + 1) % preloaded.length;
      imgEl.src = preloaded[currentIndex].src;
    }, interval);
  });
}
